import styled from "styled-components";

export const Container = styled.main`
  padding: 2rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 1.5rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    gap: 1rem;
    flex-direction: column-reverse;
    justify-content: center;

    button{
      width: 100%;
      height: 2.5rem;
    }
  }
`;

export const LoadingContainer = styled.div`
  height: 50vh;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 720px) {
    div.align_error {
      display: flex;
      flex-direction: column;
    }
  }

  div.error_div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    color: ${(props) => props.theme.colors["red-500"]};

    svg {
      margin-right: 5px;
    }
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    gap: 1rem;
  }
`;

export const InputRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 1.5rem;
  width: 20rem;

  > * {
    flex: 1;
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
   width: 100%;
  }
`;

export const MenuAccessRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem; 
  width: 100%;

  > * {
    flex: 0 0 calc(50% - 1rem);
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    flex-direction: column;
  }
`;


export const Divider = styled.div`
  background-color: ${(props) => props.theme.colors["gray-400"]};
  width: 100%;
  height: 0.0625rem;
  margin: 0 0 1.5rem 0;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: none;
  }
`;

export const Title = styled.h1`
  font-size: ${(props) => props.theme.fontSize.XXXS};
  font-weight: ${(props) => props.theme.fontWeight.Bold};
  color: ${(props) => props.theme.colors["gray-900"]};
  line-height: ${(props) => props.theme.lineHeight.Default};

`;
